import React from 'react';
import { connect } from 'react-redux';
import moment from "moment";

import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import WorkReportTemplate from './WorkReportTemplate';
import weeklyReportService from '../../services/WorkReport/weekly-report-service';
import {
	fetchLeaderWeeklyReportList,
	increaseLeaderWeeklyReportLoadCounter,
	setLeaderWeeklyReportFilter,
	updateWeeklyReportStatus
} from '../../actions/work-report-actions';
import {
	Table,
	Button,
	Modal,
	Spin,
	message,
	Row,
	Col,
	Input,
	Radio,
	DatePicker,
	Upload,
	Icon,
	Form,
	Select,
} from 'antd';

const webConfig = require('../../config.json');

class WeeklyReportReview extends React.Component {

	rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let ids = selectedRows.map(row => row.id);
			this.setState({ selectedIDs: ids });
		},
		getCheckboxProps: record => ({
			disabled: record.status === 2
		}),
	}

	state = {
		certificatePreviewVisiable: false,
		certificatePreviewImage: "",
		summaryImagePreviewVisiable: false,
		summaryImagePreviewImage: "",
		isAddtion: false
	}

	componentWillMount() {
		if ("loaded" !== this.props.workReport.leaderWeeklyReportStatus) {
			this.props.increaseLeaderWeeklyReportLoadCounter();
		}
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.workReport.leaderWeeklyReportLoadCounter !== this.props.workReport.leaderWeeklyReportLoadCounter) {
			let gets = {};
			Object.keys(nextProps.workReport.leaderWeeklyReportFilters).forEach(key => {
				if (nextProps.workReport.leaderWeeklyReportFilters[key]) {
					gets[key] = nextProps.workReport.leaderWeeklyReportFilters[key];
				}
			});
			this.props.fetchLeaderWeeklyReportList(gets);
		}
	}

	setEmployeeFilter = value => {
		this.props.setLeaderWeeklyReportFilter({ real_name: value, code: value, page: 1 });
	}

	setStartDateFilter = (value, date) => {
		this.props.setLeaderWeeklyReportFilter({ start_date: date, page: 1 });
	}

	setEndDateFilter = (value, date) => {
		this.props.setLeaderWeeklyReportFilter({ end_date: date, page: 1 });
	}

	setStatusFilter = event => {
		this.props.setLeaderWeeklyReportFilter({ status: event.target.value, page: 1 });
	}

	setPageFilter = pagination => {
		this.props.setLeaderWeeklyReportFilter({ page: pagination.current });
	}

	editReportContent = reportContent => { }

	weeklyReportDetail = id => {
		this.setState({ currentModalStatus: true });
		weeklyReportService.fetchLeaderWeeklyReportDetail({ modelId: id }, res => {

			this.setState({
				isAddtion: false,
				isEducation: false,
				isEducation_admin: false,
				foreign_report: false,
				foreign_report_admin: false,
				weeklyReportTemplate: JSON.parse(res.data.work_report.table_content),
				openDetail: true,
				real_name: res.data.employee.real_name,
				department_name: res.data.employee.department_name,
				position_name:res.data.employee.position_name,
				report_real_name: res.data.work_report.real_name,
				report_department_name: res.data.work_report.department_name,
				report_position_name:res.data.work_report.position_name,
				date_1:res.data.work_report.date_1,
				type_id: res.data.work_report.type_id,
				week_str:res.data.work_report.week_str,
				next_id: res.data.next_id,
				prev_id: res.data.prev_id,
				replies: res.data.replies,
				report_id: res.data.work_report.id,
				currentComment: "",
				currentData: {
					employee_id_1: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_id_1 ? res.data.work_report.best_employees.employee_id_1 : "",
					employee_id_2: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_id_2 ? res.data.work_report.best_employees.employee_id_2 : "",
					employee_id_3: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_id_3 ? res.data.work_report.best_employees.employee_id_3 : "",
					employee_1_reason: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_1_reason ? res.data.work_report.best_employees.employee_1_reason : "",
					employee_2_reason: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_2_reason ? res.data.work_report.best_employees.employee_2_reason : "",
					employee_3_reason: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_3_reason ? res.data.work_report.best_employees.employee_3_reason : "",
					employee_name_1: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_name_1 ? res.data.work_report.best_employees.employee_name_1 : "",
					employee_name_2: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_name_2 ? res.data.work_report.best_employees.employee_name_2 : "",
					employee_name_3: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_name_3 ? res.data.work_report.best_employees.employee_name_3 : "",
					question: res.data.work_report.question
				},
				images: res.data.work_report.images ? JSON.parse(res.data.work_report.images) : [],
				summary: res.data.work_report.summary,
				summary_images: res.data.work_report.summary_images ? JSON.parse(res.data.work_report.summary_images) : [],
			});
			if (res.data.work_report.template_name && (res.data.work_report.template_name == "周工作报告"
				|| res.data.work_report.template_name == "周工作报告(教学部)" || res.data.work_report.template_name == "周工作报告(教学部组长和主管)")) {
				this.setState({
					isAddtion: true
				})
				if (res.data.work_report.template_name == "周工作报告(教学部)" || res.data.work_report.template_name == "周工作报告(教学部组长和主管)") {
					this.setState({
						isEducation: true
					})
				}
				if (res.data.work_report.template_name == "周工作报告(教学部组长和主管)") {
					this.setState({
						isEducation_admin: true,
					})
				}
			}
			if (res.data.work_report.template_name && (res.data.work_report.template_name == "普通外教周报(转正后)" || res.data.work_report.template_name == "外教周报(主管)"
				|| res.data.work_report.template_name == "外教周报(导师)" || res.data.work_report.template_name == "外教周报(试用期)")) {
				this.setState({ foreign_report: true })
				if (res.data.work_report.template_name == "外教周报(主管)") {
					this.setState({ foreign_report_admin: true })
				}
			}
		});
	}

	setCurrentComment = event => this.setState({ currentComment: event.target.value })

	fetchPrevWeeklyReport = () => this.weeklyReportDetail(this.state.prev_id)

	fetchNextWeeklyReport = () => {
		this.replyWeeklyReport(() => this.weeklyReportDetail(this.state.next_id))
	}

	replyWeeklyReport = callback => {
		let posts = {
			report_id: this.state.report_id,
			content: this.state.currentComment
		}
		if (posts.content) {
			weeklyReportService.replyWeeklyReport(posts, res => this.replyWeeklyReportCallback(res, callback));
		} else {
			Modal.confirm({
				title: '您没有填写回复内容，确定要以空内容来回复么？',
				okText: '确认',
				cancelText: '取消',
				onOk: () => weeklyReportService.replyWeeklyReport(posts, res => this.replyWeeklyReportCallback(res, callback)),
				onCancel: () => { }
			});
		}
	}

	replyWeeklyReportCallback = (res, callback) => {
		if (res.data.Success) {
			message.success("回复报告成功", 4);
			this.props.increaseLeaderWeeklyReportLoadCounter();
			this.props.updateWeeklyReportStatus();
			if ("function" === typeof callback) {
				callback();
			} else {
				this.closeCurrentModal();
			}
		} else {
			message.success("回复报告失败 " + res.data.Errors[0], 4);
		}
	}

	closeCurrentModal = () => {
		this.setState({ currentModalStatus: false });
	}

	multiNotifyWeeklyReport = () => {
		if (!this.state.selectedIDs || 0 === this.state.selectedIDs.length) {
			message.error('请选择需要提醒的报告', 4);
			return;
		}
		if (!this.state.isNotify) {
			this.setState({ isNotify: true });
			let posts = {
				report_ids: this.state.selectedIDs
			}
			weeklyReportService.multiNotifyWeeklyReport(posts, res => {
				this.setState({ isNotify: false });
				if (res.data.Success) {
					message.success('发送提醒消息成功', 4);
				} else {
					message.error(res.data.Errors[0], 4);
				}
			}, err => {
				message.error("发送提醒消息失败,请联系管理员", 4);
				this.setState({ isNotify: false })
			})
		}
	}

	previewCertificate = image => this.setState({
		certificatePreviewVisiable: true,
		certificatePreviewImage: image.url
	})

	removeCertificate = image => {
		const imageIndex = this.state.images.map(image => image.uid).indexOf(image.uid)
		this.setState({
			images: [
				...this.state.images.slice(0, imageIndex),
				...this.state.images.slice(imageIndex + 1)
			]
		})
	}

	toggleCertificatePreviewModal = () => this.setState({
		certificatePreviewVisiable: !this.state.certificatePreviewVisiable
	})


	previewSummaryImage = image => this.setState({
		summaryImagePreviewVisiable: true,
		summaryImagePreviewImage: image.url
	})

	removeSummaryImage = image => {
		const imageIndex = this.state.summary_images.map(image => image.uid).indexOf(image.uid)
		this.setState({
			summary_images: [
				...this.state.summary_images.slice(0, imageIndex),
				...this.state.summary_images.slice(imageIndex + 1)
			]
		})
	}

	toggleSummaryImagePreviewModal = () => this.setState({
		summaryImagePreviewVisiable: !this.state.summaryImagePreviewVisiable
	})

	render() {
		const reportColumn = [{
			title: <div><div>报告人</div><div>Reporter</div></div>,
			dataIndex: 'real_name',
			key: 'real_name',
		}, {
			title: <div><div>报告时间</div><div>Report Time</div></div>,
			dataIndex: 'date_str',
			key: 'date_str',
		}, {
			title: <div><div>回复时间</div><div>Reply Time</div></div>,
			dataIndex: 'reply_time_str',
			key: 'reply_time_str',
		}, {
			title: <div><div>状态</div><div>Status</div></div>,
			dataIndex: 'status_name',
			key: 'status_name',
		}, {
			title: <div><div>操作</div><div>Action</div></div>,
			dataIndex: 'action',
			key: 'action',
			className: "daily-report-action",
			render: (text, record, index) => (
				<Button icon="info-circle-o" size="small" className="row-action-btn"
					onClick={this.weeklyReportDetail.bind(this, record.id)}>详情</Button>
			)
		}];
		const reportsFooter = [
			0 === this.state.prev_id ? null :
				<Button key={1} className="row-action-btn" type="primary"
					onClick={this.fetchPrevWeeklyReport}>上一条</Button>,
			this.props.access.weeklyReportReview.reply_value && (0 === this.state.next_id ?
				<Button key={2} className="row-action-btn" type="primary"
					onClick={this.replyWeeklyReport}>回复</Button> :
				<Button key={3} className="row-action-btn" type="primary"
					onClick={this.fetchNextWeeklyReport}>下一条</Button>),
			<Button key={4} className="row-action-btn" type="close"
				onClick={this.closeCurrentModal}>关闭</Button>
		];
		return (
			<div className="app-module-item">
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="&nbsp;"
					maskClosable={false}
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					footer={reportsFooter} >
					<div style={{ textAlign: "center", margin: "0px 0px 5px", height: "700px", overflowY: "auto" }}>
						{/* <Row style={{ fontSize: "16px" }}>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "right", paddingRight: "40px" }}>
								<span style={{ fontWeight: "bold" }}>报告人 : </span>
								<span style={{ color: "blue" }}>{this.state.report_real_name}</span>
							</Col>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left", paddingLeft: "40px" }}>
								<span style={{ fontWeight: "bold" }}>部门 : </span>
								<span style={{ color: "blue" }}>{this.state.report_department_name}</span>
							</Col>
						</Row> */}
							<Row style={{ fontSize: "16px", paddingTop: "15px" }}>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Name 姓名 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.report_real_name}</span>
							</Col>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Date 日期 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.week_str}</span>
							</Col>
						</Row>
						<Row style={{ fontSize: "16px", paddingBottom: "15px" }}>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Department 部门 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.reprot_department_name}</span>
							</Col>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Position 岗位 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.report_position_name}</span>
							</Col>
						</Row>

						{/* <WorkReportTemplate currentData={this.state.weeklyReportTemplate}
							editReportContent={this.editReportContent}
							openDetail={this.state.openDetail} /> */}
						{/* 外教周报 */}
						{this.state.isforeign &&
							<div>
								<div style={{ textAlign: "right" }}>
									<Button type="primary" onClick={this.AddClassEva}>
										<span>Add </span>
									</Button>
								</div>
								<div style={{ height: "10px", border: "0" }}></div>
								<WorkReportTemplate currentData={this.state.weeklyReportTemplate}
									iscenter={true}
									isforeign={true}
									editReportContent={this.editReportContent}
									openDetail={this.state.openDetail} />
							</div>
						}
						{/* 普通周报(教学部) */}
						{this.state.isEducation &&
							<div>

								<div style={{ height: "10px", border: "0" }}></div>
								<WorkReportTemplate currentData={this.state.weeklyReportTemplate}
									iscenter={true}
									AddEducationTable={this.AddEducationTable}
									editReportContent={this.editReportContent}
									openDetail={this.state.openDetail} />
							</div>
						}


						{/* 通用格式 */}
						{!this.state.isforeign && !this.state.isEducation &&
							<WorkReportTemplate currentData={this.state.weeklyReportTemplate}
								editReportContent={this.editReportContent}
								openDetail={this.state.openDetail} />
						}
						{/* 外教周报额外增加 */}
						{this.state.foreign_report &&
							<div>
								{!this.state.foreign_report_admin &&
									< Row style={{ fontSize: "16px", border: "1px solid #cccccc" }}>
										<Col span={24} style={{ height: "40px", lineHeight: "40px", borderWidth: "0px 1px 1px", borderStyle: "solid", borderColor: "#cccccc" }}>
											<div style={{ backgroundColor: "#1a1a1a", minHeight: "40px", lineHeight: "40px", padding: "0px 35px", textAlign: "left", fontSize: "17px", color: "#ffffff" }}>
												Outstanding Teachers and Colleagues of the Week (Please state specifically)
									</div>
										</Col>
										<Col span={8} style={{ textAlign: "center" }}>
											<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
												<Input value={this.state.currentData && this.state.currentData.employee_name_1} disabled={true} style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
											</div>
											<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
												<Input value={this.state.currentData && this.state.currentData.employee_1_reason} disabled={true} style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
											</div>
										</Col>
										<Col span={8} style={{ textAlign: "center" }}>
											<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
												<Input value={this.state.currentData && this.state.currentData.employee_name_2} disabled={true} style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
											</div>
											<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
												<Input value={this.state.currentData && this.state.currentData.employee_2_reason} disabled={true} style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
											</div>
										</Col>
										<Col span={8} style={{ textAlign: "center" }}>
											<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
												<Input value={this.state.currentData && this.state.currentData.employee_name_3} disabled={true} style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
											</div>
											<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
												<Input value={this.state.currentData && this.state.currentData.employee_3_reason} disabled={true} style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
											</div>
										</Col>
									</Row>

								}
								<div style={{ height: "10px", border: "0" }}></div>
								<Row style={{ fontSize: "16px", border: "1px solid #cccccc" }}>
									<Col span={24} style={{ height: "40px", lineHeight: "40px", borderWidth: "0px 1px 1px", borderStyle: "solid", borderColor: "#cccccc" }}>
										<div style={{ backgroundColor: "#1a1a1a", minHeight: "40px", lineHeight: "40px", padding: "0px 35px", textAlign: "left", fontSize: "17px", color: "#ffffff" }}>
											Issues and  Suggestions
                </div>
									</Col>
									<Col span={24} >
										<div style={{ minHeight: "40px", lineHeight: "40px", border: "1px solid #cccccc" }}>
											<Input.TextArea rows={8}
												value={this.state.currentData && this.state.currentData.question}
												disabled={true}
												style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
										</div>
									</Col>
								</Row>
							</div>
						}


						{this.state.isAddtion &&
							<div>
								{((this.state.images && 0 !== this.state.images.length) || !this.state.openDetail) &&
									<div style={{ padding: "15px", border: "2px solid #cccccc" }}>
										<Upload multiple
											fileList={this.state.images}
											listType="picture-card"
											disabled={this.state.openDetail}
											beforeUpload={this.beforeUpload}
											//customRequest={this.uploadCertificateImage}
											showUploadList={{
												showPreviewIcon: true,
												showRemoveIcon: !this.state.openDetail
											}}
											onPreview={this.previewCertificate}
											onRemove={this.removeCertificate}>
											{!this.state.openDetail &&
												<div>
													<Icon type="plus" />
													<div style={{ margin: "8px 0px 0px", color: "#999999" }}>上传图片</div>
												</div>}
										</Upload>
										<Modal visible={this.state.certificatePreviewVisiable}
											footer={null}
											onCancel={this.toggleCertificatePreviewModal}>
											<img alt="example" style={{ width: '100%' }} src={this.state.certificatePreviewImage} />
										</Modal>
										<div style={{ clear: "both" }}></div>
									</div>}

								<Row style={{ fontSize: "16px", border: "1px solid #cccccc", backgroundColor: "#f0f0f0" }}>
									<Col span={24} style={{ height: "40px", lineHeight: "40px", borderWidth: "0px 1px 1px", borderStyle: "solid", borderColor: "#cccccc" }}>
										<div style={{ backgroundColor: "#1a1a1a", minHeight: "40px", lineHeight: "40px", padding: "0px 35px", textAlign: "left", fontSize: "17px", color: "#ffffff" }}>
											本周工作总结
                  </div>
									</Col>
									<Col span={24} >
										<div style={{ minHeight: "40px", lineHeight: "40px", border: "1px solid #cccccc", backgroundColor: "#f0f0f0" }}>
											<Input.TextArea rows={4} autosize={{ minRows: 4, maxRows: 999 }}
												value={this.state.summary}
												disabled={true}
												style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
											{((this.state.summary_images && 0 !== this.state.summary_images.length) || !this.state.openDetail) &&
												<div style={{ padding: "8px" }}>
													<Upload multiple
														fileList={this.state.summary_images}
														listType="picture-card"
														disabled={this.state.openDetail}
														beforeUpload={this.beforeUpload}
														//customRequest={this.uploadSummaryImage}
														showUploadList={{
															showPreviewIcon: true,
															showRemoveIcon: !this.state.openDetail
														}}
														onPreview={this.previewSummaryImage}
														onRemove={this.removeSummaryImage}>
														{!this.state.openDetail &&
															<div>
																<Icon type="plus" />
																<div style={{ margin: "8px 0px 0px", color: "#999999" }}>上传图片</div>
															</div>}
													</Upload>
													<Modal visible={this.state.summaryImagePreviewVisiable}
														footer={null}
														onCancel={this.toggleSummaryImagePreviewModal}>
														<img alt="example" style={{ width: '100%' }} src={this.state.summaryImagePreviewImage} />
													</Modal>
													<div style={{ clear: "both" }}></div>
												</div>}

										</div>
									</Col>
								</Row>


								<Row style={{ fontSize: "16px", border: "1px solid #cccccc" }}>
									<Col span={24} style={{ height: "40px", lineHeight: "40px", borderWidth: "0px 1px 1px", borderStyle: "solid", borderColor: "#cccccc" }}>
										<div style={{ backgroundColor: "#1a1a1a", minHeight: "40px", lineHeight: "40px", padding: "0px 35px", textAlign: "left", fontSize: "17px", color: "#ffffff" }}>
											本周最佳员工
                </div>
									</Col>
									<Col span={8} style={{ textAlign: "center" }}>
										<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
											<Input value={this.state.currentData && this.state.currentData.employee_name_1} disabled={true} style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
										</div>
										<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
											<Input value={this.state.currentData && this.state.currentData.employee_1_reason} disabled={true} style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
										</div>
									</Col>
									<Col span={8} style={{ textAlign: "center" }}>
										<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
											<Input value={this.state.currentData && this.state.currentData.employee_name_2} disabled={true} style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
										</div>
										<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
											<Input value={this.state.currentData && this.state.currentData.employee_2_reason} disabled={true} style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
										</div>
									</Col>
									<Col span={8} style={{ textAlign: "center" }}>
										<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
											<Input value={this.state.currentData && this.state.currentData.employee_name_3} disabled={true} style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
										</div>
										<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
											<Input value={this.state.currentData && this.state.currentData.employee_3_reason} disabled={true} style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
										</div>
									</Col>
								</Row>


								<Row style={{ fontSize: "16px", border: "1px solid #cccccc" }}>
									<Col span={24} style={{ height: "40px", lineHeight: "40px", borderWidth: "0px 1px 1px", borderStyle: "solid", borderColor: "#cccccc" }}>
										<div style={{ backgroundColor: "#1a1a1a", minHeight: "40px", lineHeight: "40px", padding: "0px 35px", textAlign: "left", fontSize: "17px", color: "#ffffff" }}>
											本周问题反馈(包括家长投诉需求及心得反馈、与其他部门沟通事项)
                </div>
									</Col>
									<Col span={24} >
										<div style={{ minHeight: "40px", lineHeight: "40px", border: "1px solid #cccccc" }}>
											<Input.TextArea rows={8}
												value={this.state.currentData && this.state.currentData.question}
												disabled={true}
												style={{ width: "100%", color: "#000000", backgroundColor: "white" }} />
										</div>
									</Col>
								</Row>
							</div>}
						<div style={{ margin: "15px 0px" }}>
							<div style={{ textAlign: "left", marginBottom: "15px" }}>请在此回复此报告 : </div>
							<Input.TextArea ref="reportReply" rows={5} value={this.state.currentComment} placeholder="填写回复内容"
								onChange={this.setCurrentComment}></Input.TextArea>
						</div>
						<div style={{ textAlign: "left", height: "30px", lineHeight: "30px" }}>
							<p>报告回复列表 : </p>
							{this.state.replies &&
								this.state.replies.map(reply => {
									return (<div key={reply.id}>
										<span style={{ color: "blue" }}>{reply.real_name}</span>
										<span> ( </span>
										<span style={{ color: "blue" }}>
											{reply.reply_time ? moment(reply.reply_time).format("YYYY-MM-DD HH:MM") : ""}
										</span>
										<span> ) </span>
										<span> 回复 : </span>
										<span>{reply.content}</span>
									</div>)
								})}
						</div>
					</div>
				</Modal >
				<div style={{ marginBottom: "20px" }}>
					{/* {this.props.access.weeklyReportReview.notify_value && <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Button icon="clock-circle-o" type="primary"
							onClick={this.multiNotifyWeeklyReport}>批量提醒 Batch Remind</Button>
					</div>} */}
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Input.Search
							placeholder="报告人 工号/姓名"
							onSearch={this.setEmployeeFilter}
							style={{ width: 200 }}
							defaultValue={this.props.workReport.leaderWeeklyReportFilters.real_name}
							enterButton />
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<span style={{ marginRight: "5px" }}>开始时间 Start Time: </span>
						<DatePicker onChange={this.setStartDateFilter}
							value={this.props.workReport.leaderWeeklyReportFilters.start_date ?
								moment(this.props.workReport.leaderWeeklyReportFilters.start_date) : null} />
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<span style={{ marginRight: "5px" }}>结束时间 End Time: </span>
						<DatePicker onChange={this.setEndDateFilter}
							value={this.props.workReport.leaderWeeklyReportFilters.end_date ?
								moment(this.props.workReport.leaderWeeklyReportFilters.end_date) : null} />
					</div>
					<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
						<Radio.Group onChange={this.setStatusFilter}
							value={this.props.workReport.leaderWeeklyReportFilters.status}>
							<Radio.Button value={false}>全部 All</Radio.Button>
							<Radio.Button value="1">未回复 Unreply</Radio.Button>
							<Radio.Button value="2">已回复 Replied</Radio.Button>
						</Radio.Group>
					</div>
					<div style={{ clear: "both" }}></div>
				</div>
				{
					"loaded" === this.props.workReport.leaderWeeklyReportStatus &&
					<Table columns={reportColumn} dataSource={this.props.workReport.leaderWeeklyReportData.Data}
						rowKey={record => record.id} rowSelection={this.rowSelection}
						pagination={{
							total: this.props.workReport.leaderWeeklyReportData.Total,
							pageSize: this.props.workReport.leaderWeeklyReportData.PageSize,
							current: this.props.workReport.leaderWeeklyReportFilters.page
						}}
						onChange={this.setPageFilter} />
				}
				{"unload" === this.props.workReport.leaderWeeklyReportStatus && <div style={{ textAlign: 'center', margin: '100px 0px' }}><Spin size="large" /></div>}
				{"error" === this.props.workReport.leaderWeeklyReportStatus && <div style={{ textAlign: 'center', margin: '100px 0px' }}>{webConfig.httpFetchErrorInformation}</div>}
			</div >
		)
	}
}
const mapStateToProps = state => {
	return {
		workReport: state.workReport,
		isHR: state.user.currentUser.IsHR,
		isLeader: state.user.currentUser.IsLeader
	}
}
const mapDispatchToProps = {
	fetchLeaderWeeklyReportList,
	increaseLeaderWeeklyReportLoadCounter,
	setLeaderWeeklyReportFilter,
	updateWeeklyReportStatus
}

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(WeeklyReportReview));





// WEBPACK FOOTER //
// ./src/routes/WorkReport/WeeklyReportReview.js